import React from 'react';

const HeroImage = () => (
  <img src={require("./ConsultFGC_couch.jpg")} alt="Main ConsultFGC" ></img>
);
export default HeroImage;
